const BASE_URL: string = import.meta.env.VITE_API_BASE_URL || '';

export { BASE_URL as default, BASE_URL };
